import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {CustomScrollbarModule} from '../custom-scrollbar';
import {ScrollingBarModule} from '../scrolling-bar';
import {ScrollbarWithEndingBlindsComponent} from './scrollbar-with-ending-blinds.component';

@NgModule({
    imports: [
        CommonModule,
        CustomScrollbarModule,
        ScrollingBarModule
    ],
    declarations: [
        ScrollbarWithEndingBlindsComponent
    ],
    exports: [
        CustomScrollbarModule,
        ScrollbarWithEndingBlindsComponent
    ]
})
export class ScrollbarWithEndingBlindsModule {}
